import React, { useRef, useEffect } from "react";
import M from "materialize-css";
import "./Header.css";
import { Link } from "react-router-dom";
import { useMedia } from "../../MediaContext";
import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import PersonIcon from '@material-ui/icons/Person';
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
function Header() {
  const { state, dispatch } = useMedia();
  let navigate = useNavigate();
  const searchmodal = useRef(null);
  useEffect(() => {
    M.Modal.init(searchmodal.current);
  }, []);

  function nav() {
    if (state) {
      return [
        
        <Link to={state ? "/profile" : "/login"}>
          <h3 className="profile-pic"><PersonIcon fontSize="large"/></h3>
        </Link>,
        <Link to={state ? "/subscribepost" : "login"}>
          <h6 className="sub-post">
            <SubscriptionsIcon fontSize="large" />
          </h6>
        </Link>,

        <Link to="/login">
          <h3
            onClick={() => {
              localStorage.clear();

              dispatch({ type: "CLEAR" });
            }}
          >
            <Button
              variant="contained"
              color="secondary"
              className="btn-header"
            >
              Logout
            </Button>
          </h3>
        </Link>,
      ];
    } else {
      return [
        <Link to="/login">
          <h3>Login</h3>
        </Link>,
        <Link to="/signup">
          <h3>Signup</h3>
        </Link>,
      ];
    }
  }
  return (
    
      <div className="nav">
        <div className="Header_content">
          <div>
            <Link to={state ? "/home" : "login"}>
              <h4 className="brand-logo">Chit-Chat😉</h4>
            </Link>
          </div>

          <div
            style={{ display: "flex", gap: "1rem" }}
            className="Header-links"
          >
            {nav()}
          </div>
        </div>
      </div>
      
    
  );
}

export default Header;
